module.exports = __webpack_public_path__ + "img/purposeful-presidents-day.27377bf9.png";